import { isFunction } from 'lodash'

export const reducerMerger = (state, nextState) =>
  isFunction(nextState)
    ? { ...state, ...nextState(state) }
    : { ...state, ...nextState }
